import $ from "jquery";
import inView from "in-view";
import Sticky from "./Sticky";

export default {
    navOpened: false,
    windowLastScrollX: null,
    windowLastScrollY: null,

    init: function () {
        const that = this;
        let current_overlay = "none";
        this.$navToggle = $("[data-nav-toggle]");

        this.$navToggle.on("click", function () {
            if (that.navOpened) {
                if ($(this).data("overlay") == current_overlay) {
                    current_overlay = "none";
                    that.close();
                } else {
                    current_overlay = $(this).data("overlay");
                }
            } else {
                if ($(this).data("overlay") !== current_overlay) {
                    current_overlay = $(this).data("overlay");

                    that.open();
                } else {
                    current_overlay = $(this).data("overlay");
                }
            }
        });

        window.addEventListener("scroll", function () {
            if (!that.navOpened) return;

            that.noScroll();
        });
    },
    refreshMenuBarSticky() {
        // console.log($('.sticky-js.app-menu-bar').data('sticky'))
        // console.log($('.sticky-js.app-menu-bar')[0].sticky)

        let $appMenuBar = $(".sticky-js.app-menu-bar");
        $appMenuBar.removeData("sticky-status");
        let stickyData = $appMenuBar.data("sticky");
        if (stickyData) {
            // stickyData.updateScrollTopPosition()
            // if(typeof stickyData.options.afterSetPosition === 'function') {
            //     stickyData.options.afterSetPosition($appMenuBar[0], stickyData)
            // }
            if (typeof stickyData.setPosition === "function") {
                stickyData.setPosition($appMenuBar[0]);
            }
        }
    },
    open() {
        const that = this;

        this.navOpened = true;

        this.windowLastScrollX = window.scrollX;
        this.windowLastScrollY = window.scrollY;

        $("body").addClass("menu-open");

        //console.log('open', that.navOpened)
    },
    close() {
        const that = this;

        this.navOpened = false;

        this.windowLastScrollX = null;
        this.windowLastScrollY = null;

        $("body").removeClass("menu-open");

        // Remove listener to re-enable scroll
        // window.removeEventListener('scroll', this.noScroll);

        // refresh app menu bar sticky so that the classes can go back
        // to what it was before nav open
        setTimeout(function () {
            that.refreshMenuBarSticky();
        }, 150);
    },
    noScroll() {
        // console.log(this.windowLastScrollX, this.windowLastScrollY)

        this.windowLastScrollX =
            this.windowLastScrollX === null
                ? window.scrollX
                : this.windowLastScrollX;
        this.windowLastScrollY =
            this.windowLastScrollY === null
                ? window.scrollY
                : this.windowLastScrollY;

        // console.log(this.windowLastScrollX, this.windowLastScrollY)

        // window.scrollTo(0, 0);
        window.scrollTo(this.windowLastScrollX, this.windowLastScrollY);
    },
    searchToggle() {
        // $('.app-bar__search, [data-click="search-close"]').on('click', (e) => {
        //     e.preventDefault()
        //     $('body').toggleClass('search-active');
        //
        //     setTimeout(() => {
        //         $('.app-search form input[name="s"]').focus()
        //     }, 200)
        // })
    },
};
